<template>
  <div class="app_container container">
    <butn
      class="allBtn"
      size="mini"
      btntype="primary"
      title="全部数据"
      @click="allClick"
    ></butn>
    <img class="img" src="../../assets/image/jiaxing/cs.jpeg" />
  </div>
</template>

<script>
import butn from "@/components/button/index";
export default {
  name: "cockpit",
  components: {
    butn,
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    allClick() {
      window.open("http://223.4.74.19:8088/cs", "_blank");
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
}
.allBtn {
  width: 80px;
  height: 30px !important;
}
.img {
  margin-top: 20px;
}
</style>
